import React from 'react';
import { Helmet } from 'react-helmet';
import RegistrationHeader from './components/RegistrationHeader';
import RegistrationForm from './components/RegistrationForm';
import TrustSignals from './components/TrustSignals';
import FeatureHighlights from './components/FeatureHighlights';

const Register = () => {
  return (
    <>
      <Helmet>
        <title>Create Account - DKS Creator</title>
        <meta name="description" content="Join DKS Creator and start building amazing web applications without code. Sign up now to access our visual builder, templates, and powerful tools." />
      </Helmet>
      <div className="min-h-screen bg-background">
        <div className="container mx-auto px-4 py-6 md:py-8 lg:py-12">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 xl:gap-16 max-w-7xl mx-auto">
            <div className="flex flex-col justify-center">
              <div className="w-full max-w-md mx-auto lg:max-w-lg space-y-6 md:space-y-8">
                <RegistrationHeader />

                <div className="bg-card rounded-2xl shadow-lg border border-border p-6 md:p-8 lg:p-10">
                  <RegistrationForm />
                </div>

                <TrustSignals />
              </div>
            </div>

            <div className="hidden lg:flex flex-col justify-center">
              <FeatureHighlights />
            </div>
          </div>

          <div className="lg:hidden mt-8 md:mt-12">
            <FeatureHighlights />
          </div>
        </div>

        <footer className="border-t border-border mt-12 md:mt-16 lg:mt-20">
          <div className="container mx-auto px-4 py-6 md:py-8">
            <div className="flex flex-col sm:flex-row items-center justify-between gap-4 text-sm text-muted-foreground">
              <p>&copy; {new Date()?.getFullYear()} DKS Creator. All rights reserved.</p>
              <div className="flex items-center gap-4 md:gap-6">
                <a href="#" className="hover:text-foreground transition-colors">
                  Privacy Policy
                </a>
                <a href="#" className="hover:text-foreground transition-colors">
                  Terms of Service
                </a>
                <a href="#" className="hover:text-foreground transition-colors">
                  Contact
                </a>
              </div>
            </div>
          </div>
        </footer>
      </div>
    </>
  );
};

export default Register;